import dayjs from "dayjs";
import suggestions from "../data/response/foreis_rodos.json"

export async function fetchSuggestions() {

    const displayMessage = (d) => {
      if (!d) return;
      const name = d.NAME ? d.NAME : '';
      const description = d.DESCRIPTIO ? d.DESCRIPTIO : '';
      const foreas = d.FOREAS ? `Φορέας: ${d.FOREAS}` : '';
      
  
      const message = `<div>
        <strong>${name}</strong>
        <p>${foreas}</p>
        <p>${description}</p>
      </div>`;
  
      return message;
    }

    const features = suggestions.map((data, index) => ({
        id: index + 1,
        type: "Feature",
        properties: {
          name: data.NAME,
          displayMessage: displayMessage(data),
        },
        geometry: {
            type: "Point",
            coordinates: data.geometry.coordinates
        },
    }));

    
    // console.log("fetchSuggestions", features);

  return {
    type: "FeatureCollection",
    features,
  };
}
